import api from "@/shared/services/api";
import {
  getEmptyOperationIndicators,
  OperationIndicators,
  OperationListParams,
  OperationListResult,
} from "../types/operationList.types";

const normalizeIndicators = (value: any): OperationIndicators => {
  const empty = getEmptyOperationIndicators();
  const data = value || {};

  return {
    total: data.total || empty.total,
    void: data.void || empty.void,
    processing: data.processing || empty.processing,
    approved: data.approved || empty.approved,
    rejected: data.rejected || empty.rejected,
    completed: data.completed || empty.completed,
  };
};

const createOperationListService = (basePath = "/operation") => ({
  async getOperations(
    params: OperationListParams = {},
  ): Promise<OperationListResult> {
    const response = await api.get(`${basePath}/all`, { params });

    return {
      data: response.data?.data || [],
      totalCount: response.data?.totalCount || 0,
    };
  },

  async getStatistics(
    params: OperationListParams = {},
  ): Promise<OperationIndicators> {
    const response = await api.get(`${basePath}/statistics`, { params });
    return normalizeIndicators(response.data?.data || response.data || {});
  },
});

const operationListService = createOperationListService();

export const creditLineOperationListService = createOperationListService(
  "/credit-line/operation",
);

export type OperationListService = typeof operationListService;

export default operationListService;
